import { EmptyStateMessage } from "../empty-state-message";
import { VersionTableRowSkeleton } from "./version-table-row-skeleton";

export const VersionsTableEmptyState = () => {
  return (
    <div className="tw-relative">
      <div className="tw-opacity-80">
        {Array.from({ length: 7 }).map((_, index) => (
          <VersionTableRowSkeleton key={`skeleton-${index}`} skipLoading />
        ))}
      </div>
      <div
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)",
        }}
        className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
      >
        <EmptyStateMessage
          title="No dynamic versions found"
          description="Create a dynamic version to start collecting insights."
        />
      </div>
    </div>
  );
};
